<div class="modal-header text-center"></div>
<div class="modal-body">
  <table class="table">
    <thead>
      <tr class="table-header"></tr>
    </thead>
    <tbody
      class="table-body"
      dragula="OPTIONS"
      [dragulaModel]="options"
      (dragulaModelChange)="options = $event"
    >
      @for (option of options; track option) {
      <tr class="table-row">
        <td>
          <svg
            style="margin-top: 2px; cursor: grab"
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="18"
            viewBox="0 0 10 18"
            fill="none"
          >
            <circle cx="1" cy="1" r="1" fill="#C7C7C7" />
            <circle cx="5" cy="1" r="1" fill="#C7C7C7" />
            <circle cx="9" cy="1" r="1" fill="#C7C7C7" />
            <circle cx="1" cy="5" r="1" fill="#C7C7C7" />
            <circle cx="5" cy="5" r="1" fill="#C7C7C7" />
            <circle cx="9" cy="5" r="1" fill="#C7C7C7" />
            <circle cx="1" cy="9" r="1" fill="#C7C7C7" />
            <circle cx="5" cy="9" r="1" fill="#C7C7C7" />
            <circle cx="9" cy="9" r="1" fill="#C7C7C7" />
            <circle cx="1" cy="13" r="1" fill="#C7C7C7" />
            <circle cx="5" cy="13" r="1" fill="#C7C7C7" />
            <circle cx="9" cy="13" r="1" fill="#C7C7C7" />
            <circle cx="1" cy="17" r="1" fill="#C7C7C7" />
            <circle cx="5" cy="17" r="1" fill="#C7C7C7" />
            <circle cx="9" cy="17" r="1" fill="#C7C7C7" />
          </svg>
          <span style="margin-left: 10px">{{ option }}</span>
        </td>
      </tr>
      }
    </tbody>
  </table>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="confirm()">Save</button>
  <button class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
